import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const th = {
  IBCorporate: 'สมัคร IB ในนามองค์กร',
  IBIndividual: 'สมัคร IB ในนามบุคคล',
  MAMIndividual: 'MAM รายบุคคล',
  MAMMasterWithLPOA: 'MAM รายบุคคล',
  MarkupConfirmation: 'การยืนยัน Markup',
  UserCorporate: 'องค์กรผู้ใช้',
  UserIndividual: 'ผู้ใช้รายบุคคล',
  UserJoint: 'ผู้ใช้ร่วม',
  account: {
    bankingDetails: 'รายละเอียดธนาคาร',
    createANewAccount: 'เปิดบัญชีซื้อขาย',
    register: 'ลงทะเบียน',
    registerSignInTitle: 'เป็นสมาชิกอยู่แล้ว?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },
  adminSocialTrading: {
    title: 'Social Trading',
    investorAccountDetails: {
      tradingAccountName: 'ชื่อบัญชีซื้อขาย',
      balance: 'ยอดคงเหลือ',
      login: 'เลขบ้ญชีเทรด',
    },
    masterAccountDetails: {
      copyType: 'ชนิดในการก็อปปี้',
      groupMappingType: 'Group Mapping Type',
      login: 'เลขบ้ญชีเทรด',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'รับของขวัญวันเกิดของคุณ',
    availableTable: {
      bonusSize: 'ขนาดโบนัส',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'ไม่พบบันทึก',
    },
    captcha: {
      captchaServerIsUnavailable:
        'เซิร์ฟเวอร์ Captcha ไม่สามารถใช้งานได้ในขณะนี้ กรุณารีเฟรชหน้าจอและลองใหม่อีกครั้ง หากยังพบปัญหา กรุณาติดต่อซัพพอร์ททางแชท หรือส่งอีเมลไปที่ {{0}}',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded: 'โปรดทราบว่าเกินลิมิตสูงสุดสำหรับการแบ่งปันผลกำไรแล้ว ลิมิตสูงสุดคือ {{0}}%',
      notEnoughMoney:
        'ขออภัย แต่ท่านไม่มีเงินเพียงพอในบัญชีการซื้อขายของท่านเพื่อดำเนินการถอนเงินที่ขอ กรุณาตรวจสอบว่าท่านมีค่าคงเหลือที่เพียงพอก่อนที่จะพยายามดำเนินการถอนเงิน. โปรดทราบว่านอกจากค่าคงเหลือที่มีอยู่แล้ว ท่านยังควรพิจารณาระดับมาร์จิ้นฟรีที่ต้องการสำหรับการถอนเงินด้วย',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'ไม่สามารถเลือกบัญชีมาสเตอร์เพื่อคัดลอกได้ในขณะนี้ กรุณาลองใหม่อีกครั้งในภายหลัง',
    },
    securityCode: {
      emptyValue: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่เป็นค่าว่างหรือค่า null',
      invalidLength: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องมี {{0}} อักขร',
      invalidMinLength: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องมีอย่างน้อย {{0}} อักขระ',
      invalidMaxLength: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่เกิน {{0}} อักขระ',
      manyRepeatedValues:
        'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่มีตัวอักษรที่ซ้ำกันมากกว่า {{0}} อักขระ',
      missingNumericValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องมีตัวเลข',
      containsNumericValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่มีค่าตัวเลขใด ๆ',
      missingLowerCaseValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องมีตัวอักษรตัวเล็ก',
      containsLowerCaseValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่มีค่าตัวอักษรตัวเล็กใด ๆ',
      missingUpperCaseValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องมีตัวอักษรตัวใหญ่',
      containsUpperCaseValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่มีค่าตัวอักษรตัวใหญ่ใด ๆ',
      missingSpecialValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องมีตัวอักษรพิเศษ',
      containsSpecialValues: 'ค่าความปลอดภัยที่ป้อนเข้า (รหัสผ่านหรือรหัส PIN) ต้องไม่มีตัวอักษรพิเศษใด ๆ',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'ขออภัยในความไม่สะดวกบัญชี {{0}} ถูกปิดใช้งาน',
      ageIsAboveMaxAllowed: 'ผู้สมัครต้องมีอายุระหว่าง {{0}}-{{1}} ปีบริบูรณ์',
      ageIsUnderMinAllowed: 'We do not accept applications from anyone under {{0}} years old.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'โปรดกรอกข้อมูลในช่อง {{0}}',
      ibCodeIsIncorrect: "รหัส IB '{{0}}' ไม่ถูกต้อง กรุณากรอกรหัส IB ที่ถูกต้อง",
      invalidCredentials: 'ชื่อผู้ใช้งานไม่ถูกต้อง {{0}} และ/หรือ รหัสผ่าน',
      invalidLengthOfPhoneNumber:
        'ขออภัยหมายเลขโทรศัพท์มือถือ {{0}} มีความยาวไม่ถูกต้อง กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
      invalidLink: 'ลิงก์ไม่ถูกต้อง',
      invalidPhoneNumberLength: 'ความยาวของหมายเลขโทรศัพท์ไม่ถูกต้อง โปรดลองอีกครั้ง',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'ผู้สมัครต้องมีอายุระหว่าง {{0}} ปีบริบูรณ์',
      onlyLatinCharactersCanBeUsed: 'ใช้ได้เฉพาะอักขระภาษาละตินสำหรับช่อง {{0}}',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: 'ไม่พบผู้ใช้งาน {{0}} ',
      userEmailAlreadyExists: 'อีเมลของผู้ใช้งานได้รับการลงทะเบียนในระบบแล้ว',
      userPhoneAlreadyExists: 'โทรศัพท์ของผู้ใช้งานได้รับการลงทะเบียนในระบบแล้ว',
      cantUpdateProfileActualStatus: 'ไม่สามารถอัปเดทบัญชี {{0}}, สถานะจริง = {{1}}',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'หรือดึงไฟล์ของคุณที่นี่',
    exportFormat: 'รูปแบบการนำออก',
    getCode: 'รับรหัส',
    hide: 'ซ่อน',
    limitMessage: '{{limit}} ตัวอักษรที่เหลือ',
    resend: 'ส่งอีกครั้ง',
    seconds: 'sec',
    show: 'แสดง',
  },
  headerWithBalance: {
    serverTime: 'เวลาเซิร์ฟเวอร์',
    failedToFetchServerTime: 'การดึงข้อมูลเวลาเซิร์ฟเวอร์ล้มเหลว',
    view: 'มุมมอง',
  },
  investors: {
    blackList: 'แบล็คลิส',
  },
  legal: {
    clientAgreement: 'ข้อตกลงของลูกค้า',
    privacyPolicy: 'นธยบายความเป็นส่วนตัว',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'เกี่ยวกับ Master',
    infoFields: {
      ibCode: 'IB code',
    },
  },
  masters: {
    fields: {
      masterNickname: 'ชื่อเล่น มาสเตอร์',
      rating: 'ตำแหน่งในการจัดอันดับ',
    },
  },
  menu: {
    deposit: 'ฝากเงิน',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: "บัญชีผู้ติดตามเริ่มคัดลอกบัญชีต้นแบบ '{{MasterAccountName}}'",
      InvestorAccountWasOpened:
        "บัญชีผู้ติดตามถูกสร้างขึ้น. บัญชีผู้ติดตามเริ่มคัดลอกบัญชีต้นแบบ '{{InvestorAccountName}}'",
      InvestorAccountWasUnlinked: "บัญชีผู้ติดตามหยุดเพื่อคัดลอกบัญชีต้นแบบ '{{MasterAccountName}}'",
      MasterAccountWasChanged:
        'บัญชีหลักได้รับการแก้ไข (ส่วนแบ่งกำไร={{ProfitSharing}} วิธีการจัดสรร={{AllocationMethod}})',
      MasterAccountWasLinked: "บัญชีของผู้ติดตาม '{{InvestorAccountName}}' เริ่มคัดลอกบัญชีต้นแบบ",
      MasterAccountWasOpened:
        'สร้างบัญชีมาสเตอร์แล้ว (ส่วนแบ่งกำไร={{ProfitSharing}} วิธีการจัดสรร={{AllocationMethod}})',
      MasterAccountWasUnlinked: "บัญชีของผู้ติดตาม '{{InvestorAccountName}}' หยุดเพื่อคัดลอกบัญชีต้นแบบ",
    },
  },
  modal: {
    error: 'ข้อผิดพลาด',
    notification: 'การแจ้งเตือน',
    ok: 'ตกลง',
  },
  operationHistory: {
    filterName: 'ค้นหา',
    placeholder: 'กรุณาป้อน',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Sales',
    ibInfo: {
      detailsTitle: 'รายละเอียด IB',
      nextRebatePayment: 'การจ่ายค่ารีเบทรอบถัดไป',
      statistics: {
        closetTradersReport: {
          type: 'ประเภท',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError: 'Markups ไม่ถูกต้อง! โปรดติดต่อทีมซัพพอร์ตเพื่อ markups ที่ถูกต้อง',
    },
    salesUserInfo: {
      aeCode: 'AE Code',
    },
  },
  profile: {
    adult: 'ฉันอายุมากกว่า 18 ปีบริบูรณ์',
    code: 'รหัส',
    country: 'ประเทศ',
    documentsUploaded: 'อัปโหลดเอกสาร',
    isAgreeWithTermsAndConditions: 'ฉันยอมรับข้อกำห<0>นดและเงื่อนไข</0> และน<1>โยบายความเป็นส่วนตัว</1>',
    pleaseValidateAccountToDeposit:
      'แจ้งให้ทราบว่า คำสั่งในการฝากเงิน จะสามารถทำได้เฉพาะ บัญชีที่ยืนยันตัวตนแล้วเท่านั้น',
    successChangeDescription: 'บันทึกการเปลี่ยนแปลงแล้ว!',
    warningMessage: {
      profileIsBeingVerified: 'โปรไฟล์ของคุณกำลังได้รับการยืนยัน อาจใช้เวลาสองสามวินาที',
    },
  },
  psp: {
    accountsFetchFailErr: 'การเชื่อมต่อบัญชีล้มเหลว',
    confirmEveryTransaction: '\nยืนยันทุกธุรกรรมการฝากเงินใช้เวลาถึง 24 ชั่วโมง',
    deposit: {
      depositForm: {
        accountNameTitle: 'ชื่อบัญชี',
        addressLine2: 'ที่อยู่บรรทัดที่ 2',
        beneficiaryAccountNumberTitle: 'เลขที่บัญชี',
        beneficiaryBankHint: 'โปรดเลือกเลขบัญชีของคุณ',
        beneficiaryBankNameHint: 'ชื่อธนาคาร เช่น (ธนาคารสแตนดาร์ด ชาร์เตอร์ด)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'กรุณาอัปโหลดหลักฐานการโอนเงิน',
      },
      depositTitle: 'ฝากเงิน',
      notice: 'หมายเหตุ! คุณจะสามารถถอนเงินได้หลังจากบัญชีได้รับการอนุมัติเรียบร้อย',
      warnToSubmitPersonalDetails: 'หากต้องการฝากเงิน กรุณาส่งรายละเอียดส่วนตัวของท่าน',
    },
    localAgentTable: {
      login: 'เข้าสู่ระบบ',
    },
    operationsFetchFailErr: 'การดำเนินการล้มเหลว',
    operationsTable: {
      documentTitle: 'เอกสาร',
      operationsTableTitle: 'ประวัติการทำธุรกรรม',
      paymentSystemTitle: 'ช่องทางการทำธุรกรรม',
    },
    pluginInfoFetchFailErr: 'การดึงข้อมูลปลั๊กอินล้มเหลว',
    pluginNotFound: 'ไม่พบปลั๊กอิน',
    pluginsFetchFailErr: 'การดึงข้อมูลปลั๊กอินล้มเหลว',
    preAuthorizedBanking: 'การธนาคารที่ได้รับอนุญาตล่วงหน้า',
    qrCodeCryptoNotice:
      'QR Code ใช้ได้เพียงครั้งเดียวเท่านั้น อย่าสแกนรหัสนี้ในแอปพลิเคชัน crypto มากกว่าหนึ่งครั้ง มิฉะนั้น การชำระเงินของคุณจะถูกระงับ',
    qrCodeCryptoTitle: 'QR Code สำหรับแอปพลิเคชัน crypto',
    resentOperationsTitle: 'ประวัติการทำธุรกรรม',
    transfer: {
      transactionDetailsTitle: 'รายละเอียดการทำธุรกรรม',
      transferForm: {
        amountError: 'ยอดคงเหลือไม่พอสำหรับการโอน',
        currencyTitle: 'สกุลเงิน',
      },
    },
    uploadBankStatementWithBankName: 'อัปโหลดรายการเดินบัญชีที่มีชื่อธนาคาร, ชื่อนามสกุล เเละหมายเลขบัญชีธนาคารของคุณ',
    uploadPayslip: 'อัปโหลดสลิปการฝากเงิน',
    uploadYourDocument: 'โปรดยืนยันการฝากเงินของคุณโดยอัปโหลดหน้าสมุดบัญชีธนาคารของคุณ',
    withdrawal: {
      notice: 'การถอนสามารถทำได้เฉพาะบัญชีที่ยืนยันตัวตนแล้วเท่านั้น',
      withdrawalTitle: 'ถอนเงิน',
      withdrawalForm: {
        bankNameTitle: 'ชื่อ ธนาคาร',
        beneficiaryCryptoWalletHint: 'หมายเลขกระเป๋าเงินพร้อมเงินดิจิตอลจะถูกส่งไปยัง',
        beneficiaryCryptoWalletTitle: 'ผู้รับเงิน Crypto Wallet',
        confirmTitle: 'อัตราแลกเปลี่ยน ในการถอน ขึ้นอยู่ กับ อัตราแลกเปลี่ยนในวันที่ เงินจากระบบถูกโอนเข้าบัญชีของคุณ',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'กรุณาตรวจสอบว่าหมายเลขบนเอกสารของท่านตรงกับในภาพ',
      documentTypeHint: 'กรุณาอัปโหลดรูปหรือเอกสารที่มีรายละเอียดชัดเจนและเป็นเอกสารสี',
      uploadedDocumentsTable: {
        docNameTitle: 'ชื่อเอกสาร',
        documentNumber: 'หมายเลขเอกสาร',
        typeTitle: 'ประเภทเอกสาร',
      },
    },
    profileForm: {
      editProfileTitle: 'แก้ไขข้อมูลส่วนตัว',
      proceedToDeposit: 'ดำเนินการฝากเงิน',
      saveUserSuccessMessage: 'บันทึกข้อมูลเรียบร้อย',
      userDetailsErrorMessage: 'การดึงข้อมูลส่วนตัวล้มเหลว',
      verifyPersonalDetails: 'ยืนยันรายละเอียดส่วนบุคคล',
      verifyProfileBtn: 'ส่งข้อมูลการสมัครส่วนตัว',
    },
  },
  socialTradingModal: {
    copyHint: 'บัญชีของคุณ {{account}} จะหยุด กอปปี้ มาสเตอร์ {{oldMaster}} และจะเริ่ม กอปปี้ มาสเตอร์ {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'บัญชีซื้อขาย',
    accountHistoryForm: {
      closeTimeTitle: 'เวลาปิด',
    },
    changeTradingAccountName: 'เปลี่ยนชื่อบัญชีซื้อขาย',
    connectedAccounts: 'บัญชีเชื่อมต่อแล้ว',
    currency: 'สกุลเงิน',
    depositForm: {
      amountTitle: 'จำนวนเงิน',
      errorMessage: 'การฝากเงินล้มเหลว',
      successMessage: 'การฝากเงินสำเร็จ',
    },
    descriptionPlaceholder: 'ป้อนคำแนะนำสำหรับผู้ติดตามของคุณ',
    fetchServersErr: 'การเชื่อมต่อเซิร์ฟเวอร์ล้มเหลว',
    ibCode: 'IB (ไม่จำเป็น)',
    notRows: 'ไม่มีข้อมูล',
    openAccountModalSubTitle: 'ตราสารการซื้อขายที่หลากหลายที่สุด: สกุลเงินโลหะ เงื่อนไขการซื้อขายมาตรฐาน',
    tradingPlatforms: 'แพลตฟอร์มการเทรด',
    transferForm: {
      title: 'โอนเงิน',
    },
    withdrawForm: {
      amountTitle: 'จำนวน',
      errorMessage: 'การเปลี่ยนเลเวอเรจล้มเหลว',
      successMessage: 'การถอนเงินเสร็จสมบูรณ์',
    },
  },
} satisfies ILocaleLegacy;
